/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Spinner } from "react-bootstrap"

export const DEFAULT_BUTTON_SPINNER_SIZE = 25

export const DefaultButtonSpinner = () => {
    return (
        <Spinner animation={'border'}
            style={{ color: 'grey', height: DEFAULT_BUTTON_SPINNER_SIZE, width: DEFAULT_BUTTON_SPINNER_SIZE }} />
    )
}